import logger from '@finn-no/fiaas-logger';
import { getPageCounter } from 'shared/prometheus/prometheus';
import type { SspContext } from 'shared/types';
import { SWRConfig, type SWRConfiguration } from 'swr';
import { LmsResultPageLayout } from '@/components/lms/LmsResultPageLayout';
import { config, feConfig } from '@/config';
import type { LmsResult } from '@/interfaces/lms';
import { stringifyParams } from '@/lib/utils/queryString';
import { runAllMiddlewares } from '@/server/middleware';

type LmsPageProps = {
    ssrData: SWRConfiguration['fallbackData'];
    isLoggedIn?: boolean;
};

const LmsResultPage = ({ ssrData, isLoggedIn }: LmsPageProps) => (
    <SWRConfig value={{ fallback: ssrData }}>
        <LmsResultPageLayout isLoggedIn={isLoggedIn} />
    </SWRConfig>
);

export const getServerSideProps = async ({ req, res, query }: SspContext) => {
    if (!query.skipSSRData) {
        return { props: { ssrData: {}, hasLegalBasis: false, unleash: null, config: feConfig } };
    }

    await runAllMiddlewares(req, res, query);

    const qs = stringifyParams(query as Record<string, string>);
    const params = qs.length ? `?${qs.toString()}` : '';
    const offerUrl = `${config.get('lms.apiUrlInternal')}/offers${params}`;
    const swrKey = `${config.get('lms.apiUrlExternal')}/offers${params}`;

    const data: LmsResult | null = await fetch(offerUrl)
        .then((response): Promise<LmsResult> => response.json())
        .catch((err) => {
            logger.error(`Could not fetch lms offers data from ${offerUrl}`, err);
            return null;
        });

    getPageCounter().inc({ app: 'pale-pp-web', page: 'lms' });

    return {
        props: {
            ssrData: { [swrKey]: data },
            isLoggedIn: !!res.locals?.loginId,
            hasLegalBasis: res.locals?.hasLegalBasis ?? false,
            unleash: res.locals?.unleash ?? null,
            config: feConfig,
        },
    };
};

export default LmsResultPage;
